import { render, staticRenderFns } from "./MenuService.vue?vue&type=template&id=0cdadba5&"
import script from "./MenuService.vue?vue&type=script&lang=js&"
export * from "./MenuService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports